import { useState } from 'react';

import { useRouter } from 'expo-router';

export const useStoreLocatorDialogs = ({
  onDismissInSupportForm,
}: {
  onDismissInSupportForm?: () => void;
}) => {
  const [dismissPromptOpen, setDismissPromptOpen] = useState(false);

  const router = useRouter();

  const handleCloseDismissPrompt = () => {
    setDismissPromptOpen(false);
  };

  const onDismissCallback = () => {
    router.dismiss();
    onDismissInSupportForm?.();
  };

  return {
    dismissPromptOpen,
    handleCloseDismissPrompt,
    onDismissCallback,
  };
};
